import { render, staticRenderFns } from "./MunsterHowTo.vue?vue&type=template&id=76d65546&"
import script from "./MunsterHowTo.vue?vue&type=script&lang=js&"
export * from "./MunsterHowTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports